"use client";

import { useContext, useEffect } from "react";

import { breadcrumbContext } from "@/context/breadcrumb-context";
import { BreadCrumbLink } from "@/TS/Interfaces/global_interfaces";

function ModifyBreadcrumb({
  breadCrumbList,
}: {
  breadCrumbList: BreadCrumbLink[];
}): null {
  const [, setValue] = useContext(breadcrumbContext);
  useEffect(() => {
    setValue(breadCrumbList);
  }, [breadCrumbList, setValue]);
  return null;
}

export default ModifyBreadcrumb;
